import { useState } from "react";
const useDisableButton = (duration = 2000) => {
  const [disabled, setDisabled] = useState(false);
  const handleDisable = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, duration);
  };
  return { disabled, handleDisable };
};
export default useDisableButton;
